import { createStyles } from "@mantine/core";
import { useEffect } from "react";
import { CSSTransition } from "react-transition-group";
import { useScrollLock } from "@mantine/hooks";

import DialogBackdrop from "./DialogBackdrop/DialogBackdrop";
import { TIMEOUT } from "./constants";


const useStyles = createStyles(() => ({
  backdropOnEnter: {
    opacity: 0,
  },
  backdropOnEnterActive: {
    opacity: 1,
    transition: `opacity ${TIMEOUT}ms ease-in-out`,
  },
  backdropOnEnterDone: {
    opacity: 1,
  },
  backdropOnExit: {
    opacity: 1,
  },
  backdropOnExitActive: {
    opacity: 0,
    transition: `opacity ${TIMEOUT}ms ease-in-out`,
  },
}));

type DialogProps = {
  isOpen?: boolean;
  onClose?: () => void;
  lockScroll?: boolean;
  children: React.ReactNode;
  className?: string;
}

function DialogContainer({
  isOpen = true,
  onClose,
  lockScroll = false,
  children,
  className,
}: DialogProps) {
  const { classes } = useStyles();
  const [, setScrollLocked] = useScrollLock(false);

  useEffect(() => {
    if (lockScroll && isOpen) {
      setScrollLocked(true);
    } else {
      setScrollLocked(false);
    }
  }, [lockScroll, isOpen]);

  return (
    <CSSTransition
      in={isOpen}
      timeout={TIMEOUT}
      classNames={{
        enter: classes.backdropOnEnter,
        enterActive: classes.backdropOnEnterActive,
        enterDone: classes.backdropOnEnterDone,
        exit: classes.backdropOnExit,
        exitActive: classes.backdropOnExitActive,
      }}
      unmountOnExit
    >
      <DialogBackdrop onClick={onClose} className={className}>
        {children}
      </DialogBackdrop>
    </CSSTransition>
  )
}

export default DialogContainer;
